// ── Persona 配置类型与默认值（从 PersonaEditor 拆出，保持组件文件仅导出组件） ──
export interface IdentitySection {
  role?: string;
  domain?: string;
  experience?: string;
}

export interface MissionSection {
  primary?: string;
  scope?: string[];
  out_of_scope?: string[];
}

export interface DeliverableItem {
  name: string;
  template: string;
  format: string;
}

export interface WorkflowStep {
  step: number;
  name: string;
  action: string;
}

export interface CommunicationSection {
  tone?: string;
  style?: string;
  example_phrases?: string[];
}

export interface MetricsSection {
  user_satisfaction_target?: number;
  compliance_rate_target?: number;
  safety_incidents_target?: number;
}

export interface PersonaConfigData {
  role: string;
  tone: string;
  language: string;
  boundaries: string[];
  expression_features: Record<string, unknown>;
  identity?: IdentitySection;
  mission?: MissionSection;
  rules: string[];
  deliverables: DeliverableItem[];
  workflow: WorkflowStep[];
  communication?: CommunicationSection;
  metrics?: MetricsSection;
  advanced_capabilities: string[];
}

export interface PersonaTemplate {
  id: string;
  name: string;
  description?: string;
  category?: string;
  tags?: string[];
  config: PersonaConfigData;
  is_builtin: boolean;
}

export const DEFAULT_CONFIG: PersonaConfigData = {
  role: '',
  tone: '',
  language: '',
  boundaries: [],
  expression_features: {},
  identity: { role: '', domain: '', experience: '' },
  mission: { primary: '', scope: [], out_of_scope: [] },
  rules: [],
  deliverables: [],
  workflow: [],
  communication: { tone: '', style: '', example_phrases: [] },
  metrics: {},
  advanced_capabilities: [],
};

export function ensureConfig(data: Partial<PersonaConfigData>): PersonaConfigData {
  return {
    ...DEFAULT_CONFIG,
    ...data,
    identity: { ...DEFAULT_CONFIG.identity, ...data.identity },
    mission: { ...DEFAULT_CONFIG.mission, ...data.mission },
    communication: { ...DEFAULT_CONFIG.communication, ...data.communication },
    metrics: { ...DEFAULT_CONFIG.metrics, ...data.metrics },
    boundaries: data.boundaries || [],
    rules: data.rules || [],
    deliverables: data.deliverables || [],
    workflow: data.workflow || [],
    advanced_capabilities: data.advanced_capabilities || [],
    expression_features: data.expression_features || {},
  };
}
